import { ShoppingCartAnonSessionRequest } from "../../domain/ShoppingCartSlice/ShoppingCartAnonSessionRequest";
import { ShoppingCartItemDelete } from "../../domain/ShoppingCartSlice/ShoppingCartItemDelete";
import { ShoppingCartItemGet } from "../../domain/ShoppingCartSlice/ShoppingCartItemGet";
import { ShoppingCartItemInsert } from "../../domain/ShoppingCartSlice/ShoppingCartItemInsert";
import { ShoppingCartItemUpdate } from "../../domain/ShoppingCartSlice/ShoppingCartItemUpdate";
import ApiWrapper from "../Common/ApiWrapper";

export class ShoppingCartItemsRepository 
    extends ApiWrapper<ShoppingCartItemGet, ShoppingCartItemInsert, ShoppingCartItemUpdate, ShoppingCartItemDelete> {
    constructor() {
        super('shopping-cart-items/');
    }

    async countItems(cart: ShoppingCartAnonSessionRequest): Promise<number | null> {
        return await this.getOneCustom({ url: `count`, params: cart });
    }
}
